export default {
  // 設定頁面
  PunchBoardTitle: "戳戳樂-遊戲設定",
  candidatesLabel: "候選項目名單",
  candidatesPlaceholder: "輸入候選項目，可用換行或逗號(,)分隔，按下Enter確認新增項目，最大候選數為20人",
  candidateExists: "候選項目已存在",
  maxCandidates: "候選項目數量已達上限 (20)",
  clearSettings: "清空設定",
  saveSettings: "儲存設定",
  unsubmittedWarning: "發現到輸入框尚有未按下Enter 的項目，請確認後再儲存!"
}